import script from "./RedesignHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignHeader.vue?vue&type=script&setup=true&lang=js"

import "./RedesignHeader.vue?vue&type=style&index=0&id=356f3916&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356f3916"]])

export default __exports__